// utils/ipInformation.js

let ipInformationPromise = null;

export const getIpInformation = () => {
  if (!ipInformationPromise) {
    ipInformationPromise = fetch('https://www.planhub.ca/ip-information?dyn=1')
      .then(res => res.json())
      .catch(err => {
        console.error("Erreur IP Information:", err);
        ipInformationPromise = null; // reset pour pouvoir réessayer
        return null;
      });
  }
  return ipInformationPromise;
};
